module.exports = __webpack_public_path__ + "img/success_OLD_9.98763be6.gif";